import React from "react";

export const StatCard = ({
  title,
  value,
  change,
  icon,
  bgColor,
  iconColor,
  textColor,
  changeColor,
  onClick,
}) => (
  <div
    className={`${bgColor} border-2 border-gray-100 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 group ${onClick ? "cursor-pointer hover:border-primary-300" : ""
      }`}
    onClick={onClick}
  >
    <div className="flex items-center justify-between mb-4">
      <div
        className={`p-3 ${iconColor} rounded-xl group-hover:scale-110 transition-transform duration-300`}
      >
        {React.cloneElement(icon, { className: "text-white" })}
      </div>
      <div className="text-right">
        <p className="text-sm font-medium text-secondary-600">{title}</p>
      </div>
    </div>
    <div className="space-y-2">
      <p
        className={`text-4xl font-bold ${textColor} group-hover:scale-105 transition-transform duration-300`}
      >
        {value}
      </p>
      <p className={`text-sm font-medium ${changeColor}`}>{change}</p>
    </div>
  </div>
);
